export default __webpack_public_path__ + "static/media/Arm-straps of the Shivering Stars.9679fd43.jpg";